import DataContextProvider from "../contexts/DataContext";
import MixitContextProvider from "../contexts/MixitContext";
import TabsMixit from "../components/TabsMixit";
import Pagination from "../components/Pagination";
import ArticleLink from "../components/ArticleLink";

const Layout = () => {
  return (
    <div>
      <MixitContextProvider>
        <DataContextProvider>
          <TabsMixit />
          <Pagination />
          <ArticleLink />
          <Pagination />
        </DataContextProvider>
      </MixitContextProvider>
    </div>
  );
};

export default Layout;
